import { useCallback, useEffect, useMemo, useState } from "preact/hooks";
import PropTypes from "prop-types";
import Picker from "@/components/input/picker.input.jsx";
import useVoices from "@/hooks/useVoices.js";

TTSVoicePicker.propTypes = {
  onVoiceSelected: PropTypes.func,
  currentVoiceIndex: PropTypes.number,
  currentVoiceName: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.node,
};

export default function TTSVoicePicker({
  onVoiceSelected,
  disabled = false,
  currentVoiceName = "",
  currentVoiceIndex = -1,
  label = null,
}) {
  const voices = useVoices();
  const [voiceIndex, setVoiceIndex] = useState(currentVoiceIndex);

  const handleVoiceSelectionChange = useCallback(
    (e) => {
      const selectedVoiceIndex = e.target.value;
      const selectedVoice = voices[selectedVoiceIndex];
      onVoiceSelected({ selectedVoice, selectedVoiceIndex });
    },
    [onVoiceSelected, voices],
  );

  const voiceOptions = useMemo(() => {
    return [
      { value: "empty" },
      ...voices.map((voice, index) => ({
        name: `${voice.name}`,
        value: index,
      })),
    ];
  }, [voices]);

  useEffect(() => {
    if (voiceIndex === -1 && currentVoiceName.length > 1) {
      setVoiceIndex(voices.findIndex((voice) => voice.name === currentVoiceName));
    }
  }, [voices, currentVoiceName, voiceIndex]);

  return (
    <Picker
      emptyLabel="Please pick a voice"
      disabled={disabled}
      fieldName="selectedVoiceIndex"
      onChange={handleVoiceSelectionChange}
      label={label}
      items={voiceOptions}
      currentValue={voiceIndex}
    />
  );
}
